import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-automated-recommendation',
  templateUrl: './automated-recommendation.component.html',
  styleUrls: ['./automated-recommendation.component.scss']
})
export class AutomatedRecommendationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
